// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";

// Local Imports
import instance from "../store/axios";

export const getCountriesList = async (): Promise<any[] | undefined> => {
  try {
    const response: AxiosResponse<{
      data: any[];
      message: string;
    }> = await instance.get(
      `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/countries?partial=${1}`
    );
    return response.data.data;
  } catch (error: any) {
    if (error?.response?.status !== 401) {
      toast.error(error?.response?.data?.message || "An error occurred");
    }
    return undefined;
  }
};
